import React, { useState } from 'react'

import { Modal } from '../lib/ui/Modal'

import './AddApproverModal.css'

import { LoginType, Approver } from '../types/entities'
import { createUser } from '../actions/asyncActions'
import { ToolTip } from "../lib/ui/Tooltip"

interface Props {
  showAddApproverModal: (shown: boolean) => void
  loadAvUsers: () => void
}

const loginTypeToolTip = `Users with password login type can login to COPRA and access all views.
Users with email login type can only access timesheets via the email notification sent when a timesheet is submitted.`

export const AddApproverModal = ({ showAddApproverModal, loadAvUsers }: Props) => {
  const [approver, setApprover] = useState({
    Name: '',
    Email: '',
    LoginType: 'PASSWORD'
  } as Approver)
  const [error, setError] = useState(undefined)

  const createUserHandler = async () => {
    const result = await createUser(approver)
    if (result.status === 'FAILED') {
      setError(result.message)
    } else {
      setError(undefined)
      await loadAvUsers()
      showAddApproverModal(false)
    }
  }

  return <Modal>
    <div className='white bg-red head'>New Approver</div>
    {error && <div style={{margin: 10}} className='error'>⚠️ {error}</div>}
    <div className='modal-section'>
      <button
        onClick={createUserHandler}>Create</button>
      <button onClick={e => showAddApproverModal(false)}>Cancel</button>
    </div>
    <div className='modal-section'>
      <div className='input-block'>
        <div className='label'>
          Name:
        </div>
        <div className='value'>
          <input value={approver.Name} onChange={e => setApprover({
            ...approver, Name: e.target.value
          })} />
        </div>
      </div>
      <div className='input-block'>
        <div className='label'>
          Email:
        </div>
        <div className='value'>
          <input value={approver.Email} onChange={e => setApprover({
            ...approver, Email: e.target.value
          })} />
        </div>
      </div>
      <div className='input-block'>
        <div className='label'>
          Login type:
          <ToolTip text={loginTypeToolTip} width={350} />
        </div>
        <div className='value'>
          <select value={approver.LoginType}
            onChange={e => setApprover({
              ...approver,
              LoginType: e.target.value as LoginType
            })}
          >
            <option value='PASSWORD'>Password</option>
            <option value='EMAIL'>Email</option>
          </select>
        </div>
      </div>
    </div>
  </Modal>
}
